import React from 'react';
import './ArtistRoster.css';
import { useArtistRosterContent } from '../../../context/ContentContext';

const ArtistRoster = () => {
    const content = useArtistRosterContent();

    if (!content) return null;

    const { eyebrow, headline, subtext, artists, openSpot } = content;

    return (
        <section className="artist-roster-section" id="roster">
            <div className="artist-roster-container max-width">
                <div className="artist-roster-header">
                    <p className="artist-roster-eyebrow">{eyebrow}</p>
                    <h2 className="artist-roster-headline">
                        {headline.main}
                        <br />
                        {headline.main2}
                        <span className="artist-roster-highlight">{headline.highlight}</span>
                    </h2>
                    <p className="artist-roster-subtext">{subtext}</p>
                </div>

                <div className="artist-roster-grid">
                    {artists.map((artist, index) => (
                        <div className="artist-roster-card" key={index}>
                            <div className="artist-roster-avatar-wrap">
                                <img
                                    src={require(`../../../assets/images/${artist.image}`)}
                                    alt={`${artist.firstName} ${artist.lastName}`}
                                    className="artist-roster-avatar"
                                />
                            </div>
                            <div className="artist-roster-info">
                                <h3 className="artist-roster-name">
                                    <span className="artist-name-white">{artist.firstName} </span>
                                    <span className="artist-name-green">{artist.lastName}</span>
                                </h3>
                                <p className="artist-roster-title">{artist.title}</p>
                                <p className="artist-roster-desc">{artist.description}</p>
                            </div>
                        </div>
                    ))}

                    {/* Open Spot Card */}
                    <div className="artist-roster-card open-spot-card">
                        <div className="artist-roster-avatar-wrap open-spot-avatar-wrap">
                            {openSpot.image && (
                                <img
                                    src={require(`../../../assets/images/${openSpot.image}`)}
                                    alt=""
                                    aria-hidden="true"
                                    style={{ display: 'none' }}
                                />
                            )}
                            <span className="open-spot-plus" aria-hidden="true">+</span>
                        </div>
                        <div className="artist-roster-info">
                            <p className="open-spot-eyebrow">{openSpot.eyebrow}</p>
                            <h3 className="artist-roster-name">
                                <span className="artist-name-white">{openSpot.title1}</span>
                                <span className="artist-name-green">{openSpot.title2}</span>
                            </h3>
                            <p className="artist-roster-desc open-spot-desc">{openSpot.description}</p>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default ArtistRoster;
